import isEmpty from 'lodash-es/isEmpty'
import React from 'react'

import { Dashboard } from '@components/common'
import { HeadContent, Pagination, usePagination } from '@fourthwall/components'
import { createUseOrdersQueryParams, useOrdersQuery } from '@hooks'
import { useSearchQuery } from '@modules/Dashboard/hooks/useSearchQuery'

import { OrdersData } from './components/OrdersData/OrdersData'
import { OrdersEmptyStateWithRecommendations } from './components/OrdersEmptyStateWithRecommendations/OrdersEmptyStateWithRecommendations'
import { OrdersEmptyState } from './components/OrdersEmpyState/OrdersEmptyState'
import { SIZE } from './consts'
import { useFilterContributions } from './hooks/useFilterContributions'
import type { Order, OrderSalesChannel } from './types'

export const OrdersList = () => {
  const { searchQuery } = useSearchQuery()
  const [currentPage, setCurrentPage] = usePagination()
  const { filtersParams, hasFilterParams } = useFilterContributions()
  const { data, ordersQuery } = useOrdersQuery(
    createUseOrdersQueryParams({
      currentPage,
      size: SIZE,
      query: searchQuery,
      status: filtersParams?.status?.split(',') as Order['status'][],
      sales: filtersParams?.salesChannel?.split(',') as OrderSalesChannel[],
      types: filtersParams?.type?.split(',') as Order['type'][],
      filterOutGiveawayGifts: !searchQuery,
    }),
    { keepPreviousData: true },
  )
  const hasFilters = searchQuery || hasFilterParams
  const totalPages = data?.page.totalPages

  return (
    <>
      <HeadContent title="Orders" />

      {!isEmpty(data?.orders) || ordersQuery.isFetching ? (
        <>
          <Dashboard.Section.Item>
            <OrdersData data={data?.orders || []} isLoading={ordersQuery.isFetching} />
          </Dashboard.Section.Item>

          {totalPages && totalPages > 0 ? (
            <Dashboard.Section.Item>
              <Pagination
                pageCount={totalPages}
                currentPage={currentPage}
                onChange={setCurrentPage}
              />
            </Dashboard.Section.Item>
          ) : null}
        </>
      ) : (
        <Dashboard.Section.Item>
          {hasFilters ? <OrdersEmptyState /> : <OrdersEmptyStateWithRecommendations />}
        </Dashboard.Section.Item>
      )}
    </>
  )
}
